import { Injectable, signal } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly _title = signal<string>('');
  private readonly _icon = signal<string>('');
  private readonly _bgClass = signal<string>('bg-primary-100');
  private readonly _textClass = signal<string>('text-primary-500');
  private readonly _backIsVisible = signal<boolean>(false);

  get title() {
    return this._title();
  }

  get icon() {
    return this._icon();
  }

  get bgClass() {
    return this._bgClass();
  }

  get textClass() {
    return this._textClass();
  }

  get backIsVisible() {
    return this._backIsVisible();
  }

  setHeader(
    title: string,
    backIsVisible: boolean = false,
    icon: string = '',
    bgClass: string = 'bg-primary-100',
    textClass: string = 'text-primary-500'
  ) {
    this._title.set(title);
    this._backIsVisible.set(backIsVisible);
    this._icon.set(icon);
    this._bgClass.set(bgClass);
    this._textClass.set(textClass);
  }

  back() {
    window.history.back();
  }
}
